module.exports = __webpack_public_path__ + "img/woocommerceicon.b2d72783.svg";